import { DataManager } from "@syncfusion/ej2-data";
import { EnumFilterAdaptor } from "./enum-filter-adaptor";

export class EnumFilterDataManager<T> extends DataManager {
  constructor(dataSource: T[]) {
    super({
      json: dataSource,
      dataType: 'json',
      offline: true,
      adaptor: new EnumFilterAdaptor()
    });
  }
}
